import evompassApi from 'util/Api';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export const buildNotificationsUrl = (page = 0, size = 20, sort = 'createdAt,desc', type, unreadOnly, displayMode) => {
  let url = `notifications?page=${page}&size=${size}&sort=${sort}`;
  if (type) {
    url += `&type=${type}`;
  }
  if (unreadOnly !== undefined) {
    url += `&unreadOnly=${unreadOnly}`;
  }
  if (displayMode) {
    url += `&displayMode=${displayMode}`;
  }
  return url;
};

export const useGetNotifications = (page = 0, size = 20, sort = 'createdAt,desc', type, unreadOnly, displayMode, enabled = true) => useQuery(
  ['notifications', page, size, sort, type, unreadOnly, displayMode],
  async () => {
    const url = buildNotificationsUrl(page, size, sort, type, unreadOnly, displayMode);
    const res = await evompassApi.get(url);
    return {
      data: res.data,
      count: res.headers['x-total-count'] ? parseInt(res.headers['x-total-count'], 10) : 0,
    };
  },
  {
    onError: error => {
      console.log(error);
      toast.error('Não foi possível carregar as notificações');
    },
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled,
  }
);

export const useGetUnreadNotificationsCount = (enabled = true) => useQuery(
  ['unreadNotificationsCount'],
  async () => {
    const res = await evompassApi.get('notifications/unread-count');
    return parseInt(res.data, 10) || 0;
  },
  {
    onError: error => {
      console.log(error);
      toast.error('Não foi possível carregar a quantidade de notificações não lidas');
    },
    refetchOnWindowFocus: false,
    enabled,
  }
);

export const useSetNotificationRead = () => useMutation(
  notificationId => evompassApi.post(`notifications/${notificationId}/mark-read`).then(res => res.data),
  {
    onError: error => {
      console.log(error);
      toast.error('Não foi possível marcar a notificação como lida');
    },
  }
);
